module.exports = __webpack_public_path__ + "static/media/plus-gray.452a7d3f.svg";